export class BemTipo {
  ativo:boolean;
  id:number;
  codigoTce:string;
  tipo:string;
  categoriaId:number;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/bem-tipos/shared/bem-tipos.model.ts
 **/